<template>
  <div>
    <DataTable
      :value="refreshconfigurationData"
      :expandedRows.sync="expandedRows"
      :loading="loading"
      data-key="id"
      :paginator="true"
      :rows="10"
      :filters="filters"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 25, 50]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    >
      <template #header>
        <div class="table-header-container">
          Refresh Configuration
          <!-- <Button icon="pi pi-plus" label="Expand All" @click="expandAll" class="p-mr-2" />
          <Button icon="pi pi-minus" label="Collapse All" @click="collapseAll" />-->
        </div>
      </template>
      <template #empty>
        <strong class="text-center">No Records found.</strong>
      </template>
      <Column :expander="true" headerStyle="width: 3rem" />
      <Column
        field="name"
        header="Name"
        v-model="filters['name']"
        sortable
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['name']"
            class="p-column-filter"
            placeholder="Contains"
          />
        </template>
      </Column>
      <Column
        field="description"
        header="Description"
        v-model="filters['description']"
        sortable
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['description']"
            class="p-column-filter"
            placeholder="Contains"
          />
        </template>
      </Column>
      <Column
        field="cronInterval"
        header="Interval"
        v-model="filters['cronInterval']"
        sortable
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['cronInterval']"
            class="p-column-filter"
            placeholder="Contains"
          />
        </template>
      </Column>
      <!-- <Column field="source" header="Source" v-model="filters['source']" sortable>
        <template #filter>
          <InputText
            type="text"
            v-model="filters['source']"
            class="p-column-filter"
            placeholder="Search by Source"
          />
        </template>
      </Column>-->
      <Column
        field="lastSuccessfulRefreshDate"
        header="Last Successful Refresh Date"
        filterMatchMode="custom"
        :filterFunction="filterDate"
        sortable
      >
        <template #body="slotProps">
          {{ formatDate(slotProps.data.lastSuccessfulRefreshDate) }}
        </template>
        <template #filter>
          <Calendar
            v-model="filters['lastSuccessfulRefreshDate']"
            dateFormat="yy-mm-dd"
            class="p-column-filter"
            placeholder="Equals"
          />
        </template>
      </Column>
      <Column
        field="lastRefreshDate"
        header="Last Refresh Date"
        filterMatchMode="custom"
        :filterFunction="filterDate"
        sortable
      >
        <template #body="slotProps">
          {{ formatDate(slotProps.data.lastRefreshDate) }}
        </template>
        <template #filter>
          <Calendar
            v-model="filters['lastRefreshDate']"
            dateFormat="yy-mm-dd"
            class="p-column-filter"
            placeholder="Equals"
          />
        </template>
      </Column>
      <Column
        field="nextRefreshDate"
        header="Next Refresh Date"
        filterMatchMode="custom"
        :filterFunction="filterDate"
        sortable
      >
        <template #body="slotProps">
          {{ formatDate(slotProps.data.nextRefreshDate) }}
        </template>
        <template #filter>
          <Calendar
            v-model="filters['nextRefreshDate']"
            dateFormat="yy-mm-dd"
            class="p-column-filter"
            placeholder="Equals"
          />
        </template>
      </Column>
      <Column>
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-warning p-mr-2"
            @click="editConfig(slotProps.data)"
          />
        </template>
      </Column>
      <template #expansion="slotProps">
        <div class>
          <DataTable
            :value="slotProps.data.refreshConfigurationTypes"
            :filters="filters"
          >
            <template #empty>
              <strong class="text-center">No Records found.</strong>
            </template>
            <Column
              field="refreshType"
              header="Refresh Type"
              v-model="filters['refreshType']"
              sortable
              filterMatchMode="contains"
            >
              <template #filter>
                <InputText
                  type="text"
                  v-model="filters['refreshType']"
                  class="p-column-filter"
                  placeholder="Contains"
                />
              </template>
            </Column>
            <Column
              field="refreshDate"
              header="Refresh Date"
              filterMatchMode="custom"
              :filterFunction="filterDate"
              sortable
            >
              <template #body="slotProps">
                {{ formatDate(slotProps.data.refreshDate) }}
              </template>
              <template #filter>
                <Calendar
                  v-model="filters['refreshDate']"
                  dateFormat="yy-mm-dd"
                  class="p-column-filter"
                  placeholder="Equals"
                />
              </template>
            </Column>
            <Column
              field="refreshStatus"
              header="Latest Refresh Status"
              v-model="filters['refreshStatus']"
              sortable
              filterMatchMode="contains"
            >
              <template #body="slotProps">
                <span
                  :class="
                    'status-badge status-' +
                    slotProps.data.refreshStatus.toLowerCase()
                  "
                  >{{ slotProps.data.refreshStatus }}</span
                >
              </template>
              <template #filter>
                <InputText
                  type="text"
                  v-model="filters['refreshStatus']"
                  class="p-column-filter"
                  placeholder="Contains"
                />
              </template>
            </Column>
            <Column>
              <!-- <template #filter>
           <span> {{slotProps.data.id}}</span>
              </template>-->
              <template #body="slotProps">
                <Button
                  icon="pi pi-chart-line"
                  v-tooltip.top="'View Stats'"
                  class="p-button-primary p-button-rounded p-mr-2"
                  @click="
                    openStats(
                      slotProps.data.refreshConfigurationId,
                      slotProps.data.refreshType
                    )
                  "
                />
                <Button
                  icon="pi pi-file"
                  v-tooltip.top="'View Logs'"
                  class="p-button-primary p-button-rounded p-mr-2"
                  @click="
                    openLogs(
                      slotProps.data.refreshConfigurationId,
                      slotProps.data.refreshType
                    )
                  "
                />
                <!-- <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2" label /> -->
              </template>
            </Column>
          </DataTable>
        </div>
      </template>
    </DataTable>
    <Dialog
      header="Stats"
      maximizable
      :visible.sync="statsDialog"
      :style="{ width: '70vw' }"
      :modal="true"
    >
      <DataTable
        :value="Stats"
        :expandedRows.sync="expandedRows"
        :loading="loading"
        data-key="id"
        :paginator="true"
        :rows="5"
        :filters="statsfilters"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 25, 50]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      >
        <!-- <template #header>
        <div class="table-header-container">
          <Button icon="pi pi-plus" label="Expand All" @click="expandAll" class="p-mr-2" />
          <Button icon="pi pi-minus" label="Collapse All" @click="collapseAll" />
        </div>
        </template>-->
        <template #empty>
          <strong class="text-center">No Records found.</strong>
        </template>
        <Column :expander="true" headerStyle="width: 3rem" />
        <Column
          field="type"
          header="Type"
          v-model="statsfilters['type']"
          sortable
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText
              type="text"
              v-model="statsfilters['type']"
              class="p-column-filter"
              placeholder="Contains"
            />
          </template>
        </Column>
        <Column
          field="status"
          header="Status"
          sortable
          filterMatchMode="custom"
          :filterFunction="filterStatus"
        >
          <template #body="slotProps">
            <span
              :class="
                'status-badge status-' +
                formatStatus(slotProps.data.status).toLowerCase()
              "
              >{{ formatStatus(slotProps.data.status) }}</span
            >
          </template>
          <template #filter>
            <Dropdown
              v-model="statsfilters['status']"
              :options="filteroptions"
              placeholder="Select"
              class="p-column-filter"
              :showClear="true"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option }}</span>
              </template>
            </Dropdown>
          </template>
        </Column>
        <Column
          field="statusMessage"
          header="Status Message"
          v-model="statsfilters['statusMessage']"
          sortable
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText
              type="text"
              v-model="statsfilters['statusMessage']"
              class="p-column-filter"
              placeholder="Contains"
            />
          </template>
        </Column>
        <Column
          field="createdDate"
          header="Created Date"
          filterMatchMode="custom"
          :filterFunction="filterDate"
          sortable
        >
          <template #body="slotProps">
            {{ formatDate(slotProps.data.createdDate) }}
          </template>
          <template #filter>
            <Calendar
              v-model="statsfilters['createdDate']"
              dateFormat="yy-mm-dd"
              class="p-column-filter"
              placeholder="Equals"
            />
          </template>
        </Column>
        <Column
          field="startedDate"
          header="Started Date"
          filterMatchMode="custom"
          :filterFunction="filterDate"
          sortable
        >
          <template #body="slotProps">
            {{ formatDate(slotProps.data.startedDate) }}
          </template>
          <template #filter>
            <Calendar
              v-model="statsfilters['startedDate']"
              dateFormat="yy-mm-dd"
              class="p-column-filter"
              placeholder="Equals"
            />
          </template>
        </Column>
        <Column
          field="completedDate"
          header="Completed Date"
          filterMatchMode="custom"
          :filterFunction="filterDate"
          sortable
        >
          <template #body="slotProps">
            {{ formatDate(slotProps.data.completedDate) }}
          </template>
          <template #filter>
            <Calendar
              v-model="statsfilters['completedDate']"
              dateFormat="yy-mm-dd"
              class="p-column-filter"
              placeholder="Equals"
            />
          </template>
        </Column>
        <template #expansion="slotProps">
          <div class>
            <DataTable
              :value="slotProps.data.refreshStats"
              :filters="statschildfilters"
            >
              <template #empty>
                <strong class="text-center">No Records found.</strong>
              </template>
              <!-- <Column :expander="true" headerStyle="width: 3rem" /> -->
              <Column
                field="type"
                header="Type"
                filterMatchMode="contains"
                sortable
              >
                <template #filter>
                  <InputText
                    type="text"
                    v-model="statschildfilters['type']"
                    class="p-column-filter"
                    placeholder="Contains"
                  />
                </template>
              </Column>
              <Column field="newCount" header="New Count" sortable>
                <template #filter>
                  <InputText
                    type="text"
                    v-model="statschildfilters['newCount']"
                    class="p-column-filter"
                    placeholder="Equals"
                  />
                </template>
              </Column>
              <Column field="fetchedCount" header="Fetched Count" sortable>
                <template #filter>
                  <InputText
                    type="text"
                    v-model="statschildfilters['fetchedCount']"
                    class="p-column-filter"
                    placeholder="Equals"
                  />
                </template>
              </Column>
              <Column field="updatedCount" header="Updated Count" sortable>
                <template #filter>
                  <InputText
                    type="text"
                    v-model="statschildfilters['updatedCount']"
                    class="p-column-filter"
                    placeholder="Equals"
                  />
                </template>
              </Column>
              <Column field="deletedCount" header="Deleted Count" sortable>
                <template #filter>
                  <InputText
                    type="text"
                    v-model="statschildfilters['deletedCount']"
                    class="p-column-filter"
                    placeholder="Equals"
                  />
                </template>
              </Column>
              <template #expansion="slotProps">
                <div class>
                  <DataTable
                    :value="slotProps.data.batches"
                    :filters="statsfilters"
                  >
                    <Column
                      field="status"
                      header="Type"
                      filterMatchMode="contains"
                      sortable
                    >
                      <template #filter>
                        <InputText
                          type="text"
                          v-model="statsfilters['status']"
                          class="p-column-filter"
                          placeholder="Contains"
                        />
                      </template>
                    </Column>
                    <template #empty>
                      <strong class="text-center">No Records found.</strong>
                    </template>
                  </DataTable>
                </div>
              </template>
            </DataTable>
          </div>
        </template>
      </DataTable>
      <template #footer>
        <Button
          label="Close"
          icon="pi pi-times"
          @click="statsDialog = false"
          class="p-button-rounded p-button-danger"
        />
      </template>
    </Dialog>
    <Dialog
      header="Logs"
      :visible.sync="logsDialog"
      maximizable
      :style="{ width: '70vw' }"
      :modal="true"
    >
      <DataTable
        :value="Logs"
        :expandedRows.sync="expandedRows"
        :loading="loading"
        data-key="id"
        :paginator="true"
        :rows="5"
        :filters="logsfilters"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 25, 50]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      >
        <!-- <template #header>
        <div class="table-header-container">
          <Button icon="pi pi-plus" label="Expand All" @click="expandAll" class="p-mr-2" />
          <Button icon="pi pi-minus" label="Collapse All" @click="collapseAll" />
        </div>
        </template>-->
        <template #empty>
          <strong class="text-center">No Records found.</strong>
        </template>
        <Column :expander="true" headerStyle="width: 3rem" />
        <Column
          field="type"
          header="Type"
          v-model="logsfilters['type']"
          sortable
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText
              type="text"
              v-model="logsfilters['type']"
              class="p-column-filter"
              placeholder="Contains"
            />
          </template>
        </Column>
        <Column
          field="status"
          header="Status"
          sortable
          filterMatchMode="custom"
          :filterFunction="filterStatus"
        >
          <template #body="slotProps">
            <span
              :class="
                'status-badge status-' +
                formatStatus(slotProps.data.status).toLowerCase()
              "
              >{{ formatStatus(slotProps.data.status) }}</span
            >
          </template>
          <template #filter>
            <Dropdown
              v-model="logsfilters['status']"
              :options="filteroptions"
              placeholder="Select"
              class="p-column-filter"
              :showClear="true"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option }}</span>
              </template>
            </Dropdown>
          </template>
        </Column>
        <Column
          field="statusMessage"
          header="Status Message"
          v-model="logsfilters['statusMessage']"
          sortable
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText
              type="text"
              v-model="logsfilters['statusMessage']"
              class="p-column-filter"
              placeholder="Contains"
            />
          </template>
        </Column>
        <Column
          field="createdDate"
          header="Created Date"
          filterMatchMode="custom"
          :filterFunction="filterDate"
          sortable
        >
          <template #body="slotProps">
            {{ formatDate(slotProps.data.createdDate) }}
          </template>
          <template #filter>
            <Calendar
              v-model="logsfilters['createdDate']"
              dateFormat="yy-mm-dd"
              class="p-column-filter"
              placeholder="Equals"
            />
          </template>
        </Column>
        <Column
          field="startedDate"
          header="Started Date"
          filterMatchMode="custom"
          :filterFunction="filterDate"
          sortable
        >
          <template #body="slotProps">
            {{ formatDate(slotProps.data.startedDate) }}
          </template>
          <template #filter>
            <Calendar
              v-model="logsfilters['startedDate']"
              dateFormat="yy-mm-dd"
              class="p-column-filter"
              placeholder="Equals"
            />
          </template>
        </Column>
        <Column
          field="completedDate"
          header="Completed Date"
          filterMatchMode="custom"
          :filterFunction="filterDate"
          sortable
        >
          <template #body="slotProps">
            {{ formatDate(slotProps.data.completedDate) }}
          </template>
          <template #filter>
            <Calendar
              v-model="logsfilters['completedDate']"
              dateFormat="yy-mm-dd"
              class="p-column-filter"
              placeholder="Equals"
            />
          </template>
        </Column>
        <template #expansion="slotProps">
          <div class>
            <DataTable :value="slotProps.data.logs" :filters="logschildfilters">
              <template #empty>
                <strong class="text-center">No Records found.</strong>
              </template>
              <Column
                field="logText"
                header="Log Text"
                v-model="logschildfilters['logText']"
                sortable
                filterMatchMode="contains"
              >
                <template #filter>
                  <InputText
                    type="text"
                    v-model="logschildfilters['logText']"
                    class="p-column-filter"
                    placeholder="Contains"
                  />
                </template>
              </Column>
              <Column
                field="date"
                header="Date"
                filterMatchMode="custom"
                :filterFunction="filterDate"
                sortable
              >
                <template #body="slotProps">
                  {{ formatDate(slotProps.data.date) }}
                </template>
                <template #filter>
                  <Calendar
                    v-model="logschildfilters['date']"
                    dateFormat="yy-mm-dd"
                    class="p-column-filter"
                    placeholder="Equals"
                  />
                </template>
              </Column>
            </DataTable>
          </div>
        </template>
      </DataTable>

      <template #footer>
        <Button
          label="Close"
          icon="pi pi-times"
          @click="logsDialog = false"
          class="p-button-rounded p-button-danger"
        />
      </template>
    </Dialog>
    <Dialog
      :visible.sync="editRefreshConfigDialog"
      :style="{ width: '60vw' }"
      :modal="true"
      class="p-fluid"
    >
      <template #header>
        <span class="modalheader">
          Edit
          <span>{{ RefreshConfig.name }}</span>
        </span>
      </template>
      <div class="p-field">
        <label for="name">Interval</label>
        <InputText
          id="name"
          v-model="RefreshConfig.scheduleCron"
          required="true"
          disabled="disabled"
          :class="{ 'p-invalid': submitted && !RefreshConfig.scheduleCron }"
        />
          <small class="p-invalid" v-if="submitted && !RefreshConfig.scheduleCron"
          >Schedule Cron is required.</small
        >
      </div>
      <div>
        <CronExpressor v-model="RefreshConfig.scheduleCron" />
      </div>
      <template #footer>
        <Button
          label="Save"
          icon="pi pi-check"
          @click="saveEdit()"
          class="p-button-rounded p-button-primary"
        />
        <Button
          label="Close"
          icon="pi pi-times"
          @click="editRefreshConfigDialog = false"
          class="p-button-rounded p-button-danger"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  data() {
    return {
      isHidden: false,
      cronExpression: null,
      editRefreshConfigDialog: false,
      RefreshConfig: {},
      filters: {},
      logsfilters: {},
      logschildfilters: {},
      statsfilters: {},
      statschildfilters: {},
      nodes: null,
      refreshconfigurationData: null,
      expandedRows: [],
      statsDialog: false,
      logsDialog: false,
      Stats: [],
      Logs: [],
      filteroptions: [],
      LogStatus: [],
      submitted: false
    };
  },
  created() {
    this.loading = true;
    this.getConfigdata();
    let input = {
      Type: 'Status',
    };
    this.$store
      .dispatch('masterdata/getMasterData', input)
      .then(() => {
        this.LogStatus = this.$store.getters['masterdata/getMasterDataResult'];
        this.LogStatus.forEach((item) => {
          this.filteroptions.push(item.name);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted() {},
  methods: {
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    },
    formatStatus(value) {
      this.LogStatus.forEach((item) => {
        if (value == item.id) {
          value = item.name;
        }
      });
      return value;
    },
    filterStatus(value, filter) {
      if (
        filter === undefined ||
        filter === null ||
        (typeof filter === 'string' && filter.trim() === '')
      ) {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }
      this.LogStatus.forEach((item) => {
        if (value == item.id) {
          value = item.name;
        }
      });
      return value == filter;
    },
    filterDate(value, filter) {
      if (
        filter === undefined ||
        filter === null ||
        (typeof filter === 'string' && filter.trim() === '')
      ) {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }
      value = moment(value).format('YYYY-MM-DD');
      filter = moment(filter).format('YYYY-MM-DD');
      return value === filter;
    },
    openStats(configid, refreshtype) {
      let input = {
        RefreshConfigId: configid,
        Type: refreshtype,
      };
      this.statsfilters = {};
      this.statschildfilters = {};
      this.Stats = [];
      this.loading = true;
      this.$store
        .dispatch('refreshLogs/getRefreshConfigLogs', input)
        .then(() => {
          this.Stats = this.$store.getters['refreshLogs/getRefreshLogs'];
          this.statsDialog = true;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openLogs(configid, refreshtype) {
      let input = {
        RefreshConfigId: configid,
        Type: refreshtype,
      };
      this.logsfilters = {};
      this.logschildfilters = {};
      this.Logs = [];
      this.loading = true;
      this.$store
        .dispatch('refreshLogs/getRefreshConfigLogs', input)
        .then(() => {
          this.Logs = this.$store.getters['refreshLogs/getRefreshLogs'];
          this.logsDialog = true;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editConfig(item) {
      this.submitted = false;
      this.RefreshConfig = Object.assign({}, item);
      this.cronExpression = item.scheduleCron;
      this.editRefreshConfigDialog = true;
    },
    saveEdit() {
      this.submitted = true;
      if(this.RefreshConfig.scheduleCron){
      let that = this;
      let input = that.RefreshConfig;
      this.$store
        .dispatch('refreshconfig/updateRefreshConfigData', input)
        .then(() => {
          this.editRefreshConfigDialog = false;
          this.loading = true;
          this.getConfigdata();
          this.$toast.add({
            severity: 'success',
            summary: 'Successful',
            detail: 'Configuration Updated',
            life: 3000,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
    },
    getConfigdata() {
      this.$store
        .dispatch('refreshconfig/getRefreshConfigData')
        .then(() => {
          this.refreshconfigurationData = this.$store.getters[
            'refreshconfig/getRefreshConfigurationResult'
          ];
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.status-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.status-badge.status-success {
  background: #c8e6c9;
  color: #256029;
}
.status-badge.status-failed {
  background: #ffcdd2;
  color: #c63737;
}
.status-badge.status-notstarted {
  background: #feedaf;
  color: #8a5340;
}
.status-badge.status-inprogress {
  background: #2196f3;
  color: white;
}
.p-button {
  margin: 0;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  vertical-align: bottom;
  text-align: center;
  overflow: hidden;
  position: relative;
}
</style>
